<template>
    <div>
        <el-tooltip class="item" effect="dark" :content="selectedName"   placement="top-start">
            <el-input @click="dialogVisible=true" placeholder="请选择"  readonly v-model="selectedName">
                <el-button slot="append" @click="dialogVisible=true">
                    选择
                </el-button>
            </el-input>
        </el-tooltip>
        <el-dialog
            title="联络原因"
            :visible.sync="dialogVisible"
            width="550px"
            :modal='false'
            
            >
              <el-input @click="dialogVisible=true" placeholder="输入关键字" v-model="searchTreeName" class="lower">
                 <el-button slot="append" @click="onSearch" type="primary">
                     搜索
                 </el-button>
              </el-input>
              <el-card shadow="never" class="lower" style="height:500px;  overflow:auto;">
                    <el-tree
                        :data="treeData"
                        node-key="id"
                        ref="tree"
                        show-checkbox
                        highlight-current
                        check-strictly
                        :filter-node-method="filterNode"
                        :default-checked-keys="currentNodeKey"
                        :default-expanded-keys="currentNodeKey"
                        @check-change="handleCheckChange"
                        accordion
                        />
              </el-card>
              <el-row :gutter="20">
                    <el-col :span="8" :offset="16">
                         <el-button @click="onSubmit"  type="primary">确认</el-button>  <el-button @click="onReset">清空</el-button>
                    </el-col>
              </el-row>
        </el-dialog>
    </div>
</template>
<script>
export default {
   name:'consultationTypeTree',
   data(){
        return {
            treeData:[],
            list:[],
            dialogVisible:false,
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            selectData:[],
            selectedId:[],
            selectedName:"",
            searchTreeName:""
        
            
             
        }
   },
   props:{
     currentNodeKey:{
        type:Array,
        default:()=>[]
     }
   },
   watch:{
        dialogVisible:function(val){
            if(this.$refs.tree){
                if(val==true){
                    this.$refs.tree.setCheckedKeys([this.currentNodeKey],true);
                }else{
                    this.$refs.tree.setCheckedKeys([],true);
                }
            }else{
                
                if(val==false){
                      this.selectedId=[]
                }
            }
            
        },
        currentNodeKey:{
              handler(newVal, oldVal) {
                    console.debug(newVal)
                    if(newVal.length>0 ){
                         
                        if(JSON.stringify(newVal)!=JSON.stringify(this.selectedId)){
                              this.getTreeResult(newVal);
                              this.selectedId=newVal;
                        }
                      
                    }else{
                      this.reset();
                      
                    }
                },
                deep: true,
                immediate:true
                
              
        }
   },
   created:function(){
        this.getConsultationType();

         console.debug(this.currentNodeKey);
        if(this.currentNodeKey && this.currentNodeKey.length>0){
             this.getTreeResult(this.currentNodeKey);
        }
       
   },
   methods:{
    getConsultationType(){
        let vm = this
        this.axios
            .get('ConsultationTypes/GetConsultationTree')
            .then(function({data}){
                console.debug(data);
                vm.treeData=data.data.tree;
                vm.list = data.data.list;
            })
    },
    handleCheckChange(data, checked, indeterminate){
          if (checked) {
              this.$refs.tree.setCheckedKeys([data.id])
         }
    },
    onSubmit(){
        //this.dialogVisible=false;
        // if(this.currentNodeKey.length==0){
        //       this.getTreeResult();
        // }
        let selectedIds=this.$refs.tree.getCheckedKeys();
         
        this.$emit('onSelectedId',[...selectedIds]);
        this.dialogVisible=false;
    },
    onReset(){
         this.$emit('onSelectedId',[-1]);
         this.reset();
    },
    reset(){
         
        this.selectedName="";
        this.selectData=[];
        this.selectedId=[]
        if(this.$refs.tree){
            this.$refs.tree.setCheckedKeys([])
        }
        
    },
    getTreeResult(ids){
         
        var obj = null;
         
        if(ids){
            obj=[...ids];
        }else{
            if(this.$refs.tree){
                obj= [...this.$refs.tree.getCheckedKeys()];
            }
        }
        if(obj.length==0){
            return ;
        }
        let checked = [...obj];
        let listBase = this.list;
        //  console.log(this.$refs.tree.getHalfCheckedKeys());
        let parentObj = this.list.find(d=>d.id==checked[0]);
        if(parentObj==undefined){
            this.reset();
            return;
        }
        let parentIdList = this.fetchParentId(listBase,parentObj.parentId,obj);
        // this.selectedId=[...parentIdList];
        parentIdList = parentIdList.sort(function (a, b) {
            return a - b;
        });
        var names = [];
         parentIdList.forEach(item => {
            let objs = listBase.find(d=>d.id==item)
            if(objs){
                names.push(objs.typeName)
            }
        });
        if(names.length==0){
            this.selectedName=null;
        }else{
            this.selectedName = names.join('/')
        }
      
    },
    filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
    },
    fetchParentId(arr,parentId,ids){
         var childs = arr.find(p => p.id == parentId);
         if(childs){
            ids.push(childs.id);
            if(arr.findIndex(d=>d.parentId)>-1){
                ids = this.fetchParentId(arr,childs.parentId,ids);
            }
         }
         return ids;
    },
    onSearch(){
        this.$refs.tree.filter(this.searchTreeName);
    }
   }
}
</script>
<style scoped>
 .lower{
    margin-bottom: 15px;
 }
</style>


// WEBPACK FOOTER //
// src/components/customer/talks/consultationTypeTree.vue